package uk.co.nickthecoder.kyd

import uk.co.nickthecoder.glok.collections.asMutableObservableList
import uk.co.nickthecoder.glok.property.boilerplate.booleanProperty
import uk.co.nickthecoder.glok.property.boilerplate.stringProperty

class PickGroup(name: String = "") {

    val nameProperty by stringProperty(name)
    var name by nameProperty

    val expandedProperty by booleanProperty(true)
    var expanded by expandedProperty

    val picks = mutableListOf<Pick>().asMutableObservableList()

    override fun toString() = "PickGroup '$name' (${picks.size})"
}
